import { gql } from '@apollo/client/index.js'

export const CONFIDENCE_BAR_PARTIAL = `
  confidenceBar: json(
    id: $confidenceBarId,
    preview : $preview,
    locale : $locale
  ) {
    content
  }
`
export const CONFIDENCE_BAR_QUERY = gql`
query ConfidenceBarQuery($confidenceBarId: String! $preview: Boolean! $locale: String!){
  ${CONFIDENCE_BAR_PARTIAL}
}`
